import { render } from "./NoOfFloorsEditing.vue?vue&type=template&id=3e636f0a&ts=true"
import script from "./NoOfFloorsEditing.vue?vue&type=script&lang=ts"
export * from "./NoOfFloorsEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__